import { render } from "./Inventory_Warehouse_Selector.vue?vue&type=template&id=36fdea0d&scoped=true&ts=true"
import script from "./Inventory_Warehouse_Selector.vue?vue&type=script&lang=ts"
export * from "./Inventory_Warehouse_Selector.vue?vue&type=script&lang=ts"

import "./Inventory_Warehouse_Selector.vue?vue&type=style&index=0&id=36fdea0d&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fdea0d"]])

export default __exports__